module.exports = __webpack_public_path__ + "img/value-blocks-slider-kia.25377898.png";